/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Spin,
  Col,
  Card,
  Input,
  DatePicker,
  Tooltip,
} from 'antd';
import {
  InfoCircleOutlined,
} from '@ant-design/icons';
import {
  capitalize,
} from 'utils/normalizers';
import { getMunicipios } from 'api/catalogos';
import { ESTADO_PRE_ALTA } from 'utils/constants';
import AvatarUploader from '../../AvatarUploader';
import Select from '../../Select';

// eslint-disable-next-line react/prop-types
const EmpleadoGeneral = ({
  form,
  rules,
  selectedRowKeys,
  paises,
  estados,
  generos,
  estadoCivil,
  estadosEmpleado,
  tiposDeMovimientoDePersonal,
  nacionalidades,
  calcularEdad,
  disableEstatus,
  isBlocked,
}) => {
  const MEXICANX = 1;
  const EXTRANJERX = 2;
  const PAIS_MEXICO = 152;

  const [loading, setLoading] = useState(false);
  const [municipios, setMunicipios] = useState([]);
  const [estadoRequired, setEstadoRequired] = useState(false);
  const [esNacional, setEsNacional] = useState(true);
  const [paisesList, setPaisesList] = useState(paises);

  const changeNacionalidad = async (nacionalidad) => {
    setLoading(true);
    if (nacionalidad === EXTRANJERX) {
      setEsNacional(false);
      form.setFieldsValue({
        pais: undefined,
        estado: undefined,
        lugar_de_nacimiento: undefined,
      });
      setPaisesList(paises.filter((pais) => pais.id !== PAIS_MEXICO));
    } else if (nacionalidad === MEXICANX) {
      setEsNacional(true);
      form.setFieldsValue({
        pais: PAIS_MEXICO,
        estado: undefined,
        lugar_de_nacimiento: undefined,
      });
      setPaisesList(paises);
    }
    setLoading(false);
  };

  const changeState = async (estado) => {
    setLoading(true);
    form.setFieldsValue({
      estado_nacimiento: estado,
      lugar_de_nacimiento: undefined,
    });
    const _municipios = await getMunicipios({ estado });
    setMunicipios(_municipios);
    setLoading(false);
  };

  const cargarCumple = () => {
    const fechaNacimiento = form.getFieldValue('fecha_de_nacimiento');
    const fechaFuturo = (Date.now() - fechaNacimiento);

    if ((fechaNacimiento) && (fechaFuturo > 0)) {
      const edad = calcularEdad(fechaNacimiento);
      form.setFieldsValue({
        edad,
      });
    }
  };

  useEffect(() => {
    let mounted = true;
    setEsNacional(form.getFieldValue('nacionalidad') === MEXICANX);

    const fetch = async () => {
      const estado = form.getFieldValue('estado');
      cargarCumple();
      const _municipios = await getMunicipios({ estado });
      if (mounted) {
        setMunicipios(_municipios);
      }
    };
    fetch();
    return () => { mounted = false; };
  }, []);

  const columns = [
    {
      titleText: 'Estatus del Empleado',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  // useEffect(() => {
  // composeCURP();
  // }, [estado_nacimiento, genero, fecha_de_nacimiento,
  // _nombre, _apellido_paterno, _apellido_materno]);

  useEffect(() => {
    form.setFieldsValue({
      CURP: form.getFieldValue('CURP') || '',
      RFC: form.getFieldValue('RFC') || '',
    });
  }, []);

  const isEditing = selectedRowKeys?.length > 0;

  return (
    <Spin tip="Cargando..." spinning={loading}>
      <Form
        cols={columns}
        layout="vertical"
        form={form}
        scrollToFirstError
        name="general"
      >
        <Row gutter={10}>
          <Col xs={24} sm={24} md={8}>
            <AvatarUploader
              form={form}
              imageURL={form.getFieldValue('foto')}
            />
          </Col>

          <Col xs={24} sm={24} md={8}>
            <Tooltip
              title={
                isEditing
                  ? '¡Importante! Cambiar el No. de Empleado puede afectar referencias en nómina, historial, reportes, etc.'
                  : ''
              }
              placement="top"
            >
              <Form.Item
                name="numero_de_empleado"
                rules={rules.clave}
                label={(
                  <>
                    No. Empleado
                    {isEditing && (
                      <InfoCircleOutlined
                        style={{ marginLeft: 6, color: '#faad14' }}
                      />
                    )}
                  </>
                )}
              >
                <Input
                  allowClear
                  disabled={isBlocked && selectedRowKeys.length === 0}
                />
              </Form.Item>
            </Tooltip>
          </Col>

          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="numero_de_empleado_anterior"
              label="No. Empleado Anterior"
            >
              <Input
                allowClear
                disabled={isBlocked}
              />
            </Form.Item>
          </Col>
        </Row>
        <Card
          type="inner"
          size="small"
          className="inner-block-card"
          title="1. Nombre Completo"
          extra="Tal Como Aparece En Documentos Oficiales"
        >
          <Row gutter={10}>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="nombre"
                label="Nombre"
                rules={rules.nombre}
                hasFeedback
                normalize={capitalize}
              >
                <Input
                  allowClear
                  disabled={isBlocked}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="apellido_paterno"
                label="Apellido Paterno"
                rules={rules.solo_letras_requerido}
                hasFeedback
                normalize={capitalize}
              >
                <Input
                  allowClear
                  disabled={isBlocked}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="apellido_materno"
                label="Apellido Materno"
                rules={rules.solo_letras}
                hasFeedback
                normalize={capitalize}
              >
                <Input
                  allowClear
                  disabled={isBlocked}
                />
              </Form.Item>
            </Col>
          </Row>
        </Card>
        <Card
          type="inner"
          size="small"
          className="inner-block-card"
          title="2. Datos Personales"
          extra="Género, Nacionalidad, Nacimiento Y Estado Civil"
        >
          <Row gutter={10}>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="genero"
                label="Género"
                rules={rules.required}
                hasFeedback
              >
                <Select
                  dataSource={generos}
                  disabled={isBlocked}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="nacionalidad"
                label="Nacionalidad"
                rules={rules.required}
                hasFeedback
              >
                <Select
                  dataSource={nacionalidades}
                  onChange={changeNacionalidad}
                  disabled={isBlocked}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="pais"
                label="País"
                rules={rules.required}
                hasFeedback
              >
                <Select
                  dataSource={paisesList}
                  labelProp="nombre"
                  disabled={esNacional || !form.getFieldValue('nacionalidad') || isBlocked}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="fecha_de_nacimiento"
                label="Fecha de Nacimiento"
                rules={rules.fecha_de_nacimiento}
                hasFeedback
              >
                <DatePicker
                  placeholder=""
                  format="DD/MM/YYYY"
                  onChange={(value) => {
                    form.setFieldsValue({
                      edad: calcularEdad(value),
                    });
                  }}
                  disabled={isBlocked}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="estado_nacimiento"
                label="Estado"
                rules={rules.estado_nacimiento}
                hasFeedback
                normalize={capitalize}
              >
                <Select
                  dataSource={estados}
                  labelProp="nombre_de_AGEE"
                  disabled={!esNacional || isBlocked}
                  onChange={(value) => {
                    if (value > 0) {
                      setEstadoRequired(true);
                      changeState(value);
                    } else if (value === undefined) {
                      setEstadoRequired(false);
                      form.resetFields(['lugar_de_nacimiento']);
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="edad"
                label="Edad"
              >
                <Input disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="lugar_de_nacimiento"
                label="Municipio"
                hasFeedback
                rules={estadoRequired ? rules.required : null}
              >
                <Select
                  dataSource={municipios}
                  labelProp="nom_mun"
                  disabled={!estadoRequired || !esNacional || isBlocked}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="estado_civil"
                label="Estado Civil"
                rules={rules.required}
                hasFeedback
              >
                <Select
                  dataSource={estadoCivil}
                  disabled={isBlocked}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="tipo_sangre"
                label="Tipo de Sangre"
                rules={rules.required}
                hasFeedback
              >
                <Input
                  allowClear
                  disabled={isBlocked}
                />
              </Form.Item>
            </Col>
            {/*
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="tiene_hijos"
                label="Con Hijos"
              >
                <Select
                  trueFalse
                  allowClear
                  disabled={isBlocked}
                />
              </Form.Item>
            </Col> */}
          </Row>
        </Card>
        <Card
          type="inner"
          size="small"
          className="inner-block-card"
          title="3. Estatus Y Movimiento"
          extra="Estado Actual En Nómina"
        >
          <Row gutter={10}>
            {selectedRowKeys.length ? (
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="estado_del_empleado"
                  label="Estatus del Empleado"
                  rules={rules.required}
                  hasFeedback
                >
                  <Select
                    activeInactiveEmpleado={!disableEstatus}
                    dataSource={estadosEmpleado}
                    disabled={disableEstatus || isBlocked}
                  />
                </Form.Item>
              </Col>
            ) : (
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="estado_del_empleado"
                  label="Estatus del Empleado"
                  rules={rules.required}
                  hasFeedback
                  initialValue={ESTADO_PRE_ALTA}
                  disabled
                >
                  <Select dataSource={estadosEmpleado} disabled />
                </Form.Item>
              </Col>
            )}
            <Col xs={24} sm={24} md={16}>
              <Form.Item
                name="tipo_de_movimiento"
                label="Tipo de Movimiento"
              >
                <Select
                  dataSource={tiposDeMovimientoDePersonal}
                  labelProp="concepto"
                  keyProp="id"
                  allowClear
                  disabled={isBlocked}
                />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        <Form.Item hidden>
          <Button htmlType="submit" />
        </Form.Item>
      </Form>
    </Spin>
  );
};

export default EmpleadoGeneral;
